export enum DonationFrequency {
  ONCE = <any>'ONCE',
  MONTHLY = <any>'MONTHLY',
  QUARTERLY = <any>'QUARTERLY',
  HALFYEARLY = <any>'HALFYEARLY',
  YEARLY = <any>'YEARLY',
}
